import { PayloadAction, createSlice } from "@reduxjs/toolkit";
// Interfaces
import {
  IFundNoRiskAddTaskDTO,
  ISandooghDropdownDTO,
} from "src/Interfaces/fundNoRisk";

interface ISlice {
  selectedSandooghs: ISandooghDropdownDTO[];
  isAddEditOpen: boolean;
  addEditFormValues: IFundNoRiskAddTaskDTO;
  funds: ISandooghDropdownDTO[];
}
const initialState: ISlice = {
  selectedSandooghs: [] as ISandooghDropdownDTO[],
  isAddEditOpen: false,
  addEditFormValues: {} as IFundNoRiskAddTaskDTO,
  funds: [] as ISandooghDropdownDTO[],
};

const FundNoRiskSlice = createSlice({
  name: "fundNoRisk",
  initialState,
  reducers: {
    addEditSelectedSandooghs: (
      store,
      action: PayloadAction<ISandooghDropdownDTO[]>
    ) => {
      store.selectedSandooghs = action.payload;
    },

    setIsfundNoRiskAddEditOpen: (store, action: PayloadAction<boolean>) => {
      store.isAddEditOpen = action.payload;
    },

    setAddEditFundNotRiskFormValues: (
      store,
      action: PayloadAction<IFundNoRiskAddTaskDTO>
    ) => {
      store.addEditFormValues = action.payload;
    },

    setFunds: (store, action: PayloadAction<ISandooghDropdownDTO[]>) => {
      store.funds = action.payload;
    },
  },
});

export const {
  addEditSelectedSandooghs,
  setIsfundNoRiskAddEditOpen,
  setAddEditFundNotRiskFormValues,
  setFunds,
} = FundNoRiskSlice.actions;

export default FundNoRiskSlice.reducer;
